<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34"
      height="34"
      rx="6"
      fill="#FFD9C3"
    />
    <g clip-path="url(#clip0_1131_3133)">
      <path
        d="M15.2478 22.9817C14.6333 23.3781 13.901 23.5509 13.174 23.471C12.4471 23.391 11.7698 23.0632 11.2562 22.5426L10.8071 22.1035C10.6102 21.9021 10.5 21.6317 10.5 21.3501C10.5 21.0685 10.6102 20.798 10.8071 20.5967L12.7131 18.7106C12.9128 18.5144 13.1816 18.4044 13.4616 18.4044C13.7415 18.4044 14.0103 18.5144 14.21 18.7106C14.4114 18.9075 14.6818 19.0177 14.9634 19.0177C15.245 19.0177 15.5155 18.9075 15.7168 18.7106L18.7106 15.7169C18.8104 15.6184 18.8898 15.5012 18.9439 15.3718C18.998 15.2425 19.0259 15.1037 19.0259 14.9634C19.0259 14.8232 18.998 14.6844 18.9439 14.5551C18.8898 14.4257 18.8104 14.3084 18.7106 14.21C18.5143 14.0103 18.4044 13.7416 18.4044 13.4616C18.4044 13.1816 18.5143 12.9128 18.7106 12.7131L20.6066 10.8171C20.808 10.6202 21.0784 10.51 21.36 10.51C21.6417 10.51 21.9121 10.6202 22.1135 10.8171L22.5526 11.2662C23.0731 11.7798 23.4009 12.4571 23.4809 13.184C23.5609 13.911 23.3881 14.6433 22.9916 15.2578C20.9259 18.3022 18.2975 20.9238 15.2478 22.9817Z"
        stroke="#FF8A71"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1131_3133">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
